import { render, staticRenderFns } from "./video-small.vue?vue&type=template&id=6b93fca7&scoped=true"
import script from "./video-small.vue?vue&type=script&lang=js"
export * from "./video-small.vue?vue&type=script&lang=js"
import style0 from "./video-small.vue?vue&type=style&index=0&id=6b93fca7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b93fca7",
  null
  
)

export default component.exports